import { render } from "./CountCustoms.vue?vue&type=template&id=2b4ad5b7&scoped=true&ts=true"
import script from "./CountCustoms.vue?vue&type=script&lang=ts"
export * from "./CountCustoms.vue?vue&type=script&lang=ts"

import "./CountCustoms.vue?vue&type=style&index=0&id=2b4ad5b7&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b4ad5b7"]])

export default __exports__